import { ApolloClient, InMemoryCache, createHttpLink, useQuery as apolloUseQuery, useLazyQuery as apolloUseLazyQuery } from '@apollo/client';
export { useApolloClient, useMutation } from '@apollo/client';
import { getEnv } from '../../environment/resolve';
export const useQuery = (query, options) => {
  return apolloUseQuery(query, {
    ...options,
    ssr: false
  });
};
export const useLazyQuery = (query, options) => {
  return apolloUseLazyQuery(query, {
    ...options,
    ssr: false
  });
};

// Built lazily so the Sherlock endpoint resolves from the browser hostname
// (module scope would freeze it to the SSG/build-time fallback).
let sherlockGQLclient;
const getSherlockClient = () => {
  if (!sherlockGQLclient) {
    sherlockGQLclient = new ApolloClient({
      link: createHttpLink({
        uri: getEnv().sherlockGQL,
        credentials: 'include'
      }),
      cache: new InMemoryCache()
    });
  }
  return sherlockGQLclient;
};
export const useSherlockQuery = (query, options) => useQuery(query, {
  ...options,
  client: getSherlockClient()
});
export const useSherlockLazyQuery = (query, options) => useLazyQuery(query, {
  ...options,
  client: getSherlockClient()
});